import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "./loader";
import { useDispatch } from "react-redux";
import { setAuthDetails } from "../redux/RTK/authSlice";
import { jwtDecode } from "jwt-decode";
import { clearToken } from "../redux/RTK/authSlice";
function Login() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
 // const hardcodedToken = "eyJhbGciOiJIUzI1NiJ9.eyJVbmlxdWVJRCI6IjM5OTI5MTlfMTc1Nzg1NDcyMTQ1OSIsInNlc3Npb25Ub21lb3V0SW5NaW51dGUiOiI0ODAiLCJkaXZOdW1iZXIiOiIxMDAwIiwiQXBwVXNlcklkIjozOTkyOTE5LCJ1c2VyTmFtZSI6IkhpYmJlcnRBZG1pbiIsImVudiI6IkRFViIsImlzc3VlciI6ImF1dGggc2VyZXZyIiwiY29tcERpdklkIjo1NjEsImNvbXBOdW1iZXIiOiIxMjg2IiwiaWFjSWQiOm51bGwsIkFwcElkIjozNzg0LCJVc2VySWQiOjMyMjM3NzAsImV4cCI6MTc1Nzg4MzUyMTQ1OX0.Mu5PwEmgvKunSNjFfqla1s8UeURy095GfO3eTPRTZis=";
// mapping of URL with route
  useEffect(() => {
    dispatch(clearToken());
    const searchParams = new URLSearchParams(location.search);
    const urlToken = searchParams?.get("jwtToken");
    const company = searchParams?.get("companyName");
    const urlRoute = searchParams?.get("urlRoute");
    const userId = searchParams?.get("userId");
    const processToken = () => {
      if (urlToken) {
        try {
          const decodedToken = jwtDecode(urlToken);

          dispatch(
            setAuthDetails({
              token: urlToken,
              companyName: company,
              clientId: decodedToken?.currentCompanyNumber,
              divisionNumber: decodedToken?.currentCompDivNumber,
              exp: decodedToken?.exp,
              userId: userId,
            }),
          );


          if (urlRoute === "orderaddress") {
            navigate("/orderaddress");
          } else if (urlRoute === "veevaReconcile") {
            navigate("/veevaReconcile");
          } else if (urlRoute === "postageDC") {
            navigate("/postageDataCollection");
          } else {
            navigate("/home");
          }
        } catch (err) {
          console.error("Failed to decode token:", err);
          setError("Access Denied: A valid token is required.");
        }
      } else {
        setError("Access Denied: No token provided.");
      }
      setLoading(false);
    };

    const timer = setTimeout(processToken, 2000);

    return () => clearTimeout(timer);
  }, [location, navigate, dispatch]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div className="access-info">{error}</div>;
  }

  return null;
}

export default Login;
